import { NetworkStatuses } from '@strata/constants';
import { formatPhoneNumber } from '@strata/helper-functions';
import { ActionButtonPageTitle } from '@strata/react-buttons';
import { FormHeaderAndContent } from '@strata/react-form-header-and-content';
import {
    AddressHeaderLabelValue,
    FormTitleLabel,
    HeaderLabelValuePair,
} from '@strata/react-label-value-pairs';
import { LiteSupplierTag } from '@strata/react-tags';
import { useEffect } from 'react';
import { useParams } from 'react-router';

import { ReferralGrid } from 'components/shared/ReferralGrid';
import { Permissions } from 'services/constants';
import { useGoBack } from 'services/navigationHelpers';
import { AppRoutes } from 'services/routes';
import { useAppSelector } from 'store';
import { useGetSupplierDetailsQuery } from 'store/api/referenceApi';

const backToDestinationDefault = {
    route: AppRoutes.pharmacies,
    text: 'Pharmacies',
};

export const PharmacyDetailsPage = () => {
    const { npi } = useParams() as { npi: string };
    const { permissions } = useAppSelector((state) => state.auth);

    const { data: supplierDetails, isLoading } = useGetSupplierDetailsQuery({ npi });

    const { backToDestination, goBack } = useGoBack(backToDestinationDefault);

    // navigate back to product list if npi is invalid
    useEffect(() => {
        if (!isLoading && !supplierDetails?.npi) {
            goBack(true);
        }
    }, [supplierDetails, isLoading, goBack]);

    return (
        <FormHeaderAndContent
            rowOneContentHeader={
                <ActionButtonPageTitle
                    label={backToDestination.text}
                    title="Pharmacy Details"
                    id="pharmacy-details-back-button"
                    onClick={() => goBack()}
                />
            }
            rowTwoContentHeader={
                <>
                    <FormTitleLabel
                        label={
                            supplierDetails?.name && (
                                <div className="flex__gap--small" style={{ alignItems: 'center' }}>
                                    {supplierDetails.name}
                                    <LiteSupplierTag
                                        lite={
                                            supplierDetails.networkStatus === NetworkStatuses.LITE
                                        }
                                    />
                                </div>
                            )
                        }
                    />
                    <AddressHeaderLabelValue
                        label="Pharmacy Address"
                        address1={supplierDetails?.address1}
                        address2={supplierDetails?.address2}
                        city={supplierDetails?.city}
                        state={supplierDetails?.state}
                        zip={supplierDetails?.zip}
                    />
                    <HeaderLabelValuePair
                        label="Phone"
                        value={formatPhoneNumber(supplierDetails?.phone)}
                    />
                    <HeaderLabelValuePair
                        label="Fax"
                        value={formatPhoneNumber(supplierDetails?.fax)}
                    />
                </>
            }
            className="tabbed-grid-content"
            mainContent={
                permissions.includes(Permissions.READ_DETAIL) && (
                    <ReferralGrid
                        title="Pharmacy Referrals"
                        supplierNpi={npi}
                        parentLocationName="Pharmacy Details"
                    />
                )
            }
        />
    );
};
